import React from 'react';
import { graphql } from 'gatsby';

import PropTypes from 'prop-types';
import Layout from '../components/layout';
import Blog from '../templates/blog';
import SEO from '../components/seo';
import Header from '../components/header';

const AboutPage = ({
  data: {
    allContentfulBlog: { edges: blog },
    allContentfulContacts: { edges: rawContacts },
  },
  location,
}) => {
  const contacts = {};
  // eslint-disable-next-line no-return-assign
  rawContacts.forEach(({ node: { type, value } }) => (contacts[type] = value));
  return (
    <Layout>
      <SEO
        lang="ru"
        title="Блог"
        keywords={[
          'блог',
          'статьи',
          'контакты',
          'отель',
          'гостевой',
          'дом',
          'hotel',
          'guest',
          'house',
          'dom',
          'yalta',
          'гостевой дом',
          'guest house',
          'dom_yalta',
          'аренда жилья в ялте 2019',
          'отдых в ялте 2019',
          'семейный отдых',
        ]}
      />
      <Header contacts={contacts} location={location} sticky />
      <main className="main">
        <div className="pagecontent">
          <div className="container">
            <Blog items={blog} />
          </div>
        </div>
      </main>
    </Layout>
  );
};

export const query = graphql`
  query {
    allContentfulContacts {
      edges {
        node {
          id
          type
          value
        }
      }
    }
    allContentfulBlog(sort: { fields: [createdAt], order: DESC }) {
      edges {
        node {
          id
          slug
          title
          createdAt(formatString: "MMMM Do, YYYY")
          image {
            id
            file {
              url
            }
            fixed(width: 130, resizingBehavior: SCALE) {
              ...GatsbyContentfulFixed_tracedSVG
            }
          }
          body {
            json
          }
        }
      }
    }
  }
`;

AboutPage.propTypes = {
  data: PropTypes.shape({
    allContentfulBlog: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
    allContentfulContacts: PropTypes.shape({
      edges: PropTypes.array,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape().isRequired,
};

export default AboutPage;
